
// => Styling
import styles from './HtmlPngEditorView.module.css';

// => Components
import SegmentedControl from '../../components/SegmentedControl';

// => React
import { useState, useRef, useCallback, useEffect } from 'react';

// => 3rd party
import { toPng } from 'html-to-image';


// ============
// Component
// ============
const HtmlPngEditorView = ({
    requestCloseEditor = () => {},
}) => {

    const targetRef = useRef(null)
    const [imgUrl, setImgUrl] = useState(null)

    const onSaveClick = useCallback(() => {
        if (targetRef.current === null) {
            console.log("ref NULL!")
            return
        }

        toPng(targetRef.current, {cacheBust: true})
            .then((dataUrl) => {
                const link = document.createElement('a')
                link.download = 'test.png'
                link.href = dataUrl
                link.click()
                console.log("png saved.")
            })
            .catch((err) => {
                console.log(err)
            })

    }, [targetRef])

    useEffect(() => {
        if (targetRef.current === null) {
            console.log("ref NULL!")
            return
        }

        toPng(targetRef.current, {cacheBust: true})
            .then((dataUrl) => {
                setImgUrl(dataUrl)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [targetRef])

    const onRefresh = useCallback(() => {
        if (targetRef.current === null) {
            console.log("ref NULL!")
            return
        }

        toPng(targetRef.current, {cacheBust: true})
            .then((dataUrl) => {
                setImgUrl(dataUrl)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [targetRef])

    const viewModes = [
        {id: 'viewmode_html', label: 'HTML preview'},
        {id: 'viewmode_png', label: 'PNG preview'},
    ]
    const [activeViewMode, setActiveViewMode] = useState(viewModes[0].id)
    const [previewShadow, setPreviewShadow] = useState(true)
    const [previewOverflow, setPreviewOverflow] = useState(false)


    // RENDER
    // ---------
    return(
        <div className={styles.container}>
            <span className={styles.title}>HTML2PNG Editor</span>
            <span className={styles.desc}>Edit content of HTML canvas in 'src/view/dev/HtmlPngEditorView.js' and save result  as PNG.</span>
            <div className={styles.btnRow}>
                <button onClick={onSaveClick}>Save PNG result</button>
                <button onClick={requestCloseEditor}>Close Editor</button>
            </div>
            <div className={styles.btnRow}>
                <span><input id="chckbx_shadowed" type='checkbox' checked={previewShadow} onChange={(e)=>setPreviewShadow(e.target.checked)}/><label htmlFor='chckbx_shadowed'>Shadow</label></span>
                <span><input id="chckbx_hideOverflow" type='checkbox' checked={previewOverflow} onChange={(e)=>setPreviewOverflow(e.target.checked)} /><label htmlFor='chckbx_hideOverflow'>Show overflow</label></span>
            </div>

            <div style={{alignSelf: 'center'}}>
                <SegmentedControl items={viewModes} activeItem={activeViewMode} onSelect={(v)=>{
                        setActiveViewMode(v)
                        onRefresh()
                    }} />
            </div>

            <div className={styles.editor}>
                
                {/* HTML canvas */}
                <div className={styles.canvas} style={{display: activeViewMode === viewModes[0].id ? 'flex' : 'none'}}>
                    <div ref={targetRef} className={[previewShadow ? styles.shadowed : null, previewOverflow ? null : styles.overflowHide].join(" ")}>
        
                        {/* EDIT THIS */}
                        <div className={styles.card}>
                            <div className={styles.fxCommon} />
                        </div>


                    </div>
                </div>

                {/* PNG canvas */}
                <div className={styles.canvas} style={{display: activeViewMode === viewModes[1].id ? 'flex' : 'none'}}>
                        <img src={imgUrl} alt="no src!" />
                </div>

            </div>
        </div>
    );
}


export default HtmlPngEditorView